import React from 'react';

const ErrorMessage = ({ message = 'Failed to load data. Please try again.', onRetry }) => {
    return (
        <div className="alert alert-danger d-flex flex-column align-items-center justify-content-center text-center p-4 my-4 w-100 rounded shadow-sm" role="alert">
            <i className="fa fa-exclamation-triangle fa-2x mb-2 text-danger"></i>
            <h5 className="alert-heading mb-2">Something went wrong</h5>
            <p className="mb-3">{message}</p>
            {onRetry && (
                <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={onRetry}
                >
                    <i className="fa fa-refresh mr-2"></i> Try Again
                </button>
            )}
        </div>
    );
};

export default ErrorMessage;

